import { m as mergeUrlWithHost } from './lookups-705fb53e.js';
import './request.constants-deb285e0.js';

const addHostToHmcUrls = (host, object, properties = [
  'categoryProductConfiguratorUrl',
  'rangeTooltipUrl',
  'questionnaireUrl',
  'selectorConfigUrl',
]) => {
  properties.forEach((property) => {
    if (object[property]) {
      const hostWithLocale = `${host}${(object[property].startsWith('/zh/') ? 'cn' : '')}`;
      object[property] = mergeUrlWithHost(hostWithLocale, object[property]);
    }
  });
};

export { addHostToHmcUrls as a };
